// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"18":"3e5f2eed","173":"228e5349","576":"228e5349"}[chunkId] + ".chunk.css";
};